import {
  isCommitmentLineItem,
  isPromotionLineItem,
  isProductLineItem,
  isMeteredCreditLineItem,
} from '@vy/services';
import {
  isFixedLineItem,
  isPerUnitLineItem,
  isTiersUsageLineItem,
  isUsageLineItem,
  isVolumeBasedTiersLineItem,
} from '@vy/services';
import type { LineItem } from '@vy/types';

export function useLineItemsSplitter(lineItems: LineItem[]) {
  const productLineItems = lineItems.filter((lineItem) => !lineItem.isRevised && isProductLineItem(lineItem));

  const fixedLineItemsWithPromotions = productLineItems.filter(isFixedLineItem);
  const promotionLineItems = productLineItems.filter(isPromotionLineItem);
  const fixedLineItems = fixedLineItemsWithPromotions.filter(
    (lineItem) => !promotionLineItems.includes(lineItem),
  );
  const creditsLineItems = productLineItems.filter(isMeteredCreditLineItem);
  const usageLineItems = productLineItems
    .filter(isUsageLineItem)
    .filter((usageLineItem) => !isMeteredCreditLineItem(usageLineItem));

  const tiersUsageLineItems = productLineItems.filter(isTiersUsageLineItem);
  const perUnitUsageLineItems = productLineItems.filter(isPerUnitLineItem);
  const commitmentLineItems = productLineItems.filter(isCommitmentLineItem);
  const volumeTiersLineItems = productLineItems.filter(isVolumeBasedTiersLineItem);

  return {
    fixedLineItems,
    usageLineItems,
    creditsLineItems,
    tiersUsageLineItems,
    perUnitUsageLineItems,
    commitmentLineItems,
    promotionLineItems,
    volumeTiersLineItems,
  };
}
